import React, { useState } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import { Clock } from "react-bootstrap-icons"; 

export default function Timeline() {
  const allData = [
    {
      date: "24 Sep 2026",
      title: "Documentation",
      desc: "Document system processes, policies, and procedures."
    },
    {
      date: "20 Sep 2026",
      title: "Testing And Quality Assurance",
      desc: "Perform Unit testing, integration testing, and user acceptance testing"
    },
    {
      date: "10 Sep 2026",
      title: "System Design and Configuration",
      desc: "Set up modules, workflows, and user roles"
    },
    {
      date: "2 Sep 2026",
      title: "Requirements Gathering",
      desc: "Collect requirement from HR, IT, and end-users."
    },
    {
      date: "1 Sep 2026",
      title: "Planning and Preparation",
      desc: "Identify objectives, deliverables, and stakeholders."
    },
    {
      date: "28 Aug 2026",
      title: "Project Kickoff",
      desc: "Initial project discussion and planning."
    },
    {
      date: "25 Aug 2026",
      title: "Team Formation",
      desc: "Assign roles and responsibilities."
    }
  ];

  const [visibleCount, setVisibleCount] = useState(5);
  const visibleData = allData.slice(0, visibleCount);

  return (
    <div className="container-fluid p-4 bg-light">
      
      {/* Heading with icon */}
      <h5 className="fw-semibold mb-4 d-flex align-items-center gap-2">
        <Clock size={18} /> Time line
      </h5>

      <div className="card shadow-sm border-0 p-4">
        <div className="position-relative timeline-wrapper">

          {visibleData.map((item, i) => (
            <div
              className="row align-items-center mb-4 position-relative timeline-item"
              key={i}
              style={{ animationDelay: `${i * 0.15}s` }}
            >
              

              <div className="col-md-2 text-end small">
                {item.date}
              </div>


              <div className="col-md-1 d-flex justify-content-center position-relative">
                <div
                  className="timeline-dot"
                  style={{ animationDelay: `${i * 0.15}s` }}
                ></div>
              </div>


              <div className="col-md-9">
                <h6 className="mb-1 fw-bold">{item.title}</h6>
                <p className="mb-0 text-muted small">{item.desc}</p>
              </div>

            </div>
          ))}

          {/* Load More */}
          {visibleCount < allData.length && (
            <div className="text-center mt-4">
              <button
                className="btn btn-light border rounded-pill px-4"
                onClick={() => setVisibleCount((prev) => prev + 2)}
              >
                ⏳ Load More
              </button>
            </div>
          )}

        </div>
      </div>

      {/* CSS */}
      <style>{`
        .timeline-wrapper::before {
          content: "";
          position: absolute;
          left: calc(20.3%);
          top: 0;
          width: 2px;
          height: 100%;
          background: #d1d1d1;

          transform: scaleY(0);
          transform-origin: top;
          animation: growLine 1s ease forwards;
        }

        @keyframes growLine {
          to {
            transform: scaleY(1);
          }
        }

        .timeline-item {
          opacity: 0;
          transform: translateY(30px);
          animation: slideUp 0.6s ease forwards;
        }

        @keyframes slideUp {
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }

        .timeline-dot {
          width: 16px;
          height: 16px;
          background: #fff;
          border: 3px solid #d1d1d1;
          border-radius: 50%;
          z-index: 2;

          transform: scale(0);
          animation: popIn 0.4s ease forwards;
        }

        @keyframes popIn {
          to {
            transform: scale(1);
          }
        }
      `}</style>
    </div>
  );
}